<template>
  <section class="hero">
    <div class="container">
      <div v-if="banners.length" class="hero__slider">
        <div
          class="hero__track"
          :style="{ transform: `translateX(-${current * 100}%)` }"
        >
          <div
            v-for="(banner, index) in banners"
            :key="index"
            class="hero__slide"
          >
            <div class="hero__img-wrap">
              <img
                v-if="banner.image"
                :src="banner.image"
                :alt="banner.name || 'banner'"
                class="hero__img"
              />
              <div v-else class="hero__placeholder">
                <span class="hero__logo-go">Go</span> Trust
              </div>
            </div>
            <div v-if="banner.name" class="hero__caption">
              <p class="hero__name">{{ banner.name }}</p>
              <p v-if="banner.description" class="hero__desc">
                {{ banner.description }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="banners.length > 1" class="hero__dots">
          <button
            v-for="(_, index) in banners"
            :key="index"
            class="hero__dot"
            :class="{ 'hero__dot--active': index === current }"
            @click="goTo(index)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroBanner',
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: 0,
      timer: null,
    }
  },
  watch: {
    banners() {
      if (this.current >= this.banners.length) {
        this.current = 0
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.banners.length > 1) {
        this.current = (this.current + 1) % this.banners.length
      }
    }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    goTo(index) {
      this.current = index
    },
  },
}
</script>

<style scoped>
.hero {
  padding: 16px 0;
}

.hero__slider {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-xl);
}

.hero__track {
  display: flex;
  transition: transform 0.5s ease;
}

.hero__slide {
  position: relative;
  min-width: 100%;
  flex-shrink: 0;
}

.hero__img-wrap {
  height: 180px;
  background: var(--color-bg-light);
}

.hero__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero__placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 800;
  color: var(--color-primary);
}

.hero__logo-go {
  color: var(--color-accent);
}

.hero__caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 32px 20px 16px;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.55),
    rgba(0, 0, 0, 0)
  );
  color: #fff;
}

.hero__name {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
}

.hero__desc {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.9;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hero__dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.hero__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  border: none;
  padding: 0;
  transition: background 0.3s, transform 0.3s;
}

.hero__dot--active {
  background: #fff;
  transform: scale(1.2);
}

@media (min-width: 768px) {
  .hero {
    padding: 24px 0;
  }

  .hero__img-wrap {
    height: 320px;
  }

  .hero__name {
    font-size: 24px;
  }

  .hero__desc {
    font-size: 14px;
  }

  .hero__dots {
    bottom: 16px;
  }
}
</style>
